import React, { Component } from 'react';
import PublicProjectsApi from '../lib/SHub.API.PublicProjects.js';
import { connect } from "react-redux";

class ForgeViewer extends Component {
    constructor(props) {
        super(props);

        this.docs = [];
        this.views = {};
        this.viewer = null;
        this.viewerDiv = React.createRef();

        this.state = {
            enable: false,
            error: false,
            empty: true,
            view: null
        };

        if (typeof props.urn !== 'undefined' && props.urn !== '')
            this.docs.push(props.urn);
    }

    componentWillUnmount() {
        // console.log("!!!!!!!!! Forge Viewer will unmount !!!!!!!!!!!")
        if (this.viewer) {
            // I added this to handle some specific cases
            if (this.viewer.impl.selector) {
                // console.log("tearing down forge viewer ....")
                this.viewer.tearDown()
                this.viewer.finish()
                this.viewer = null
            }
        }

        this.docs = [];
        this.views = {};

        this.setState({
            enable: false,
            error: false,
            empty: true,
            view: null
        })
    }

    handleDocumentLoaded(doc, viewables) {
        if (viewables.length === 0) {
            // console.error('Document contains no viewables.');
        }
        else {
            // console.log('Document contains viewables.', viewables);
            this.setState({ view: viewables[0] });
            this.loadView(viewables[0])
        }
    }

    handleDocumentError(viewer, error) {
        console.log('Error loading a document');
    }

    getBrowserSize() {
        var w, h;

        if (typeof document.documentElement !== 'undefined' && typeof document.documentElement.clientWidth !== 'undefined' && document.documentElement.clientWidth !== 0) {
            w = document.documentElement.clientWidth; //IE
            h = document.documentElement.clientHeight;
        }
        else {
            w = document.body.clientWidth; //IE
            h = document.body.clientHeight;
        }
        return { 'width': w, 'height': h };
    }

    handleModelLoaded(viewer, model) {
        let browserSize = this.getBrowserSize()

        if (browserSize.width < 600) {
            let navTools = this.viewer.toolbar.getControl('navTools')
            if (navTools) {
                navTools.setVisible(false)
            }

            let measureTools = this.viewer.toolbar.getControl('measureTools')
            if (measureTools) {
                measureTools.setVisible(false)
            }

            let modelTools = this.viewer.toolbar.getControl('modelTools')
            if (modelTools) {
                modelTools.setVisible(false)
            }

            let settingsTools = this.viewer.toolbar.getControl('settingsTools')
            if (settingsTools) {
                settingsTools.setVisible(false)
            }
        }

        if (this.viewer) {
            this.viewer.fitToView(true);
            this.viewer.autocam.setCurrentViewAsHome(true);
            this.viewer.setLightPreset(0);
            this.props.onRef(this)
            this.props.whatsNext()
        }
    }

    handleModelError(viewer, error) {
        console.log('Error loading the model.');
    }

    getForgeToken() {
        return new Promise(function (resolve, reject) {
            let ppApi = new PublicProjectsApi();
            ppApi.Authenticate().then(response => {
                if (response.ok) {
                    response.json().then(json => {
                        // console.log(json);
                        resolve({
                            access_token: json.access_token,
                            expires_in: 1800,
                            token_type: "Bearer"
                        });
                    });
                }

            }).catch(function (err) {
                console.log(err);
                reject(err);
            });
        });
    }

    handleTokenRequested(onAccessToken) {
        // console.log('Token requested by the viewer.');

        if (onAccessToken) {
            this.getForgeToken().then(function (data) {
                try {
                    // console.log("forge token : ", data)
                    if (data)
                        onAccessToken(data.access_token, 1800);
                }
                catch (ex) {
                    console.log(ex)
                }
            });
        }
    }

    handleViewerError(errorCode) {
        console.error('Error loading Forge Viewer. - errorCode:', errorCode);
    }

    clearErrors() {
        this.setState({ error: false });
    }

    loadView(view) {
        // console.log('loading view:', view.viewableID);
        this.views[view.viewableID] = view;

        let svfUrl = view.doc.getViewablePath(view);
        let successHandler = this.handleModelLoaded.bind(this);
        let errorHandler = this.handleModelError.bind(this);
        let modelOptions = {
            sharedPropertyDbPath: view.doc.getPropertyDbPath()
        };

        //load the specified model
        if (this.viewer) {
            this.viewer.loadModel(
                svfUrl, modelOptions, successHandler, errorHandler
            );
        }
    }

    handleLoadDocumentSuccess(doc) {
        let views = this.props.Autodesk.Viewing.Document.getSubItemsWithProperties(
            doc.getRootItem(), { 'type': 'geometry' }, true
        );
        //augment viewables with the doc they came from
        views.forEach(viewable => {
            viewable.doc = doc;
        })

        //raise an event so caller can select a viewable to display
        this.handleDocumentLoaded(doc, views);
    }

    handleLoadDocumentError(errorCode) {
        this.setState({ error: true });
        console.error('Error loading Forge document - errorCode:' + errorCode);
    }

    loadDocument(urn) {
        let documentId = `urn:${urn}`;
        let successHandler = this.handleLoadDocumentSuccess.bind(this);
        let errorHandler = this.handleLoadDocumentError.bind(this);

        this.props.Autodesk.Viewing.Document.load(
            documentId, successHandler, errorHandler
        );
    }

    reviewDocuments() {
        if (this.viewer) {
            this.clearErrors();
            this.setState({ empty: (this.docs.length === 0) });
            this.docs.forEach(urn => {
                this.loadDocument(urn);
            });
        }
    }

    handleViewerInit() {
        let container = this.viewerDiv.current;
        this.viewer = new this.props.Autodesk.Viewing.Private.GuiViewer3D(container);
        var errorCode = this.viewer.start();

        if (!errorCode) {
            console.log('Forge Viewer has successfully started.');
            this.setState({ enable: true });
            this.reviewDocuments();
        } else {
            console.error('Error starting Forge Viewer - code:', errorCode);
            this.handleViewerError(errorCode);
        }
    }

    componentDidMount() {
        let options = {
            env: 'AutodeskProduction', getAccessToken: this.handleTokenRequested.bind(this)
        };

        this.props.Autodesk.Viewing.Initializer(
            options, this.handleViewerInit.bind(this));
    }

    render() {
        return (
            <div ref={this.viewerDiv}>
            </div>
        );
    }
}

const mapStateToProps = ({ app }) => ({
    app,
});

export default connect(mapStateToProps)(ForgeViewer);